// extracted by mini-css-extract-plugin
export default {"Status_wrapper":"cancelorder_Status_wrapper__Cvl4j","completed":"cancelorder_completed__GciNR","pending":"cancelorder_pending__StR50","rejected":"cancelorder_rejected__kyUOB"};